export const ADMIN_PLAYER_FORMATION = 'ADMIN_PLAYER_FORMATION'
export const ADMIN_PLAYER_LANDING = 'ADMIN_PLAYER_LANDING'
export const ADMIN_PLAYER_HAS_CHANGE = 'ADMIN_PLAYER_HAS_CHANGE'
export const ADMIN_PLAYER_INDEX = 'ADMIN_PLAYER_INDEX'
export const ADMIN_PLAYER_BUG = 'ADMIN_PLAYER_BUG'
